import React from 'react';
import { assest } from '../../Assest/Assest';

function Filling() {
  return (
    <div style={styles.container}>
      <img 
        src={assest.FillingandSealants}
        alt="Filling and Sealants"
        style={styles.image}
      />
      <div style={styles.content}>
        <h2 style={styles.title}>Dental Fillings & Sealants</h2>
        <p style={styles.text}>
          Dental fillings and sealants are effective treatments for cavities and decay prevention. Fillings are used to restore 
          the function and shape of a tooth that has been damaged by decay. They are placed into the cavity left by a decayed 
          tooth to prevent further damage and restore its function.
        </p>
        <p style={styles.text}>
          Sealants, on the other hand, are thin, protective coatings applied to the chewing surfaces of your back teeth to 
          prevent cavities from forming. These treatments are quick, painless, and highly effective in preventing further decay 
          and protecting your teeth for years to come.
        </p>
        <p style={styles.text}>
          Our team uses high-quality materials for both fillings and sealants, ensuring a durable, long-lasting result. If 
          you’re looking for a solution to tooth decay or want to protect your teeth from future cavities, schedule a consultation 
          with us today to learn more about how fillings and sealants can help you maintain a healthy smile.
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: '#f9f9f9',
    padding: '40px',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s ease-in-out',
    maxWidth: '900px',
    margin: '0 auto',
    textAlign: 'center',
  },
  image: {
    width: '100%',
    maxWidth: '800px',
    height: 'auto',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
    transition: 'transform 0.3s ease-in-out',
  },
  content: {
    marginTop: '30px',
  },
  title: {
    fontSize: '2.5rem',
    color: '#2e2e2e',
    fontWeight: '700',
    marginBottom: '20px',
  },
  text: {
    fontSize: '1.1rem',
    color: '#555',
    lineHeight: '1.7',
    maxWidth: '800px',
    margin: '0 auto',
    paddingBottom: '10px',
    transition: 'color 0.3s ease-in-out',
  },
};

export default Filling;
